<template>
<transition name="fade" appear>
  <section class="order-status" :class="{ 'green-gradient': isReady, 'orange-gradient': !isReady }">
    <i v-if="!isReady" class="far fa-clock"></i>
    <i v-else class="fas fa-check"></i>
    <p v-if="isReady">Your order is ready</p>
    <p v-else>Your order is not ready</p>
  </section>
</transition>
</template>

<script>
export default {
  props: {
    isReady: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    filename () {
      return this.isReady ? 'ReadyWhite.png' : 'clock.png'
    }
  }
}
</script>

<style lang="scss" scoped>
  .order-status {
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    align-items: center;
    -webkit-display: flex;
    -webkit-flex-direction: row;
    -webkit-justify-content: space-around;
    -webkit-align-items: center;
    border-radius: 10px;
    -webkit-border-radius: 10px;
    transition: all 0.5s ease-out;
    -webkit-transition: all 0.5s ease-out;
    width: 90%;
    max-width: 400px;
    min-height: 80px;
    margin: 15px;

    i {
      font-size: 50px;
      margin: 10px;
      color: white;
    }

    p {
      text-align: left;
      padding: 10px;
      margin: 0px;
      width: 70%;
      font-family: 'Rubik', sans-serif;
      font-weight: 600;
      font-size: 26px;
      color: #FFFFFF
    }
  }

  @media screen and (max-width: 320px) {
    i {
      font-size: 40px;
      margin: 5px;
    }
    p {
      font-size: 20px;
    }
  }

  .fade-enter-active, .fade-leave-active {
    transition: opacity 1s;
  }
  .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/order/OrderStatus.vue